import { Banner } from 'component/Banner/Banner'
import { ProfileOptions } from 'component/ProfileOptions'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { controller } from 'store/controller'
import { store } from 'store/store'

export const ProfileBanner = observer(() => {
  const onCancel = useLatestCallback(() => {
    controller.closeCreateProfile()
  })

  if (!store.createProfile) return null

  return (
    <Banner
      title={i18n('SelectProfileType')}
      scroll={false}
      onCancel={onCancel}
    >
      <ProfileOptions />
    </Banner>
  )
})
